import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Grid from "@material-ui/core/Grid/Grid";
import Countdown from "react-countdown";
import LoopIcon from "@material-ui/icons/Loop";
import React, { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import LockIcon from "@material-ui/icons/Lock";
import { Formik, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import { USER_REGISTER_RESET } from "../../redux/user/userConstants";
import {
    register,
    confirmation,
    createPassword,
} from "../../redux/user/userActions";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
const validationSchema = yup.object().shape({
    acceptTerms: yup
        .boolean()
        .oneOf([true], "پذیرفتن قوانین سایت الزامی می باشد."),
    mobileNumber: yup
        .string("شماره موبایل خود را وارد کنید")
        .required("شماره موبایل الزامی می باشد.")
        .matches(/^[0-9]+$/, "شماره موبایل تنها شامل اعداد است.")
        .min(11, "شماره موبایل شامل 11 رقم می باشد.")
        .max(11, " شماره موبایل شامل 11 رقم می باشد."),
});
const validationConfirm = yup.object().shape({
    ConfirmValue: yup
        .string()
        .required("کد تایید الزامی می باشد.")
        .matches(/^[0-9]+$/, "کد تایید تنها شامل اعداد است.")
        .min(6, "کد تایید شامل 6 رقم می باشد.")
        .max(6, " کد تایید شامل 6 رقم می باشد."),
});
const validationInfo = yup.object().shape({
    fullName: yup.string().required("نام و نام خانوادگی الزامی مباشد."),
    password: yup
        .string()
        .required("رمز عبور الزامی است"),
    // .matches(
    //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    //   "رمز عبور باید شامل اعداد ، حروف ، کلمات ویژه و حداقل 8 رقم باشد"
    // ),
    passwordRepeat: yup
        .string()
        .required("تکرار رمز عبور الزامی میباشد")
        .oneOf([yup.ref("password"), null], "رمز عبور با تکرار آن یکسان نمی باشد."),
});
const useStyles = makeStyles(() => ({
    textOrange: {
        color: "#FF9C09",
        cursor: "pointer",
        fontWeight: "bold",
    },
    red: {
        color: "red",
    },
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "bold",
    },
    text: {
        color: "blue",
        fontWeight: "bold",
        cursor: "pointer",
    },
}));

export const SignUp = (props) => {
    const [registerStep1, setRegisterStep1] = React.useState(true);
    const [registerStep2, setRegisterStep2] = React.useState(false);
    const [registerStep3, setRegisterStep3] = React.useState(false);
    const [registerStep4, setRegisterStep4] = React.useState(false);
    const [show, setShow] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [resend, setResend] = React.useState(true);
    const [registerMobileValue, setRegisterMobileValue] = React.useState(null);
    const [userTokenLocal, setUserTokenLocal] = React.useState("");
    const [confirmValue, setConfirmValue] = React.useState("");
    const [dates, setDates] = React.useState(0);
    const classes = useStyles();
    const dispatch = useDispatch();
    const clockRef = useRef();
    const userRegister = useSelector((state) => state.userRegister);
    const { data } = userRegister;
    const userConfirm = useSelector((state) => state.userConfirm);
    const { confirmData } = userConfirm;
    const userCreate = useSelector((state) => state.userCreate);
    const { userCreateData } = userCreate;

    function alert(message) {
        switch (message) {
            case "VerifyCodeWasSent":
                return props.success("کد تایید با موفقیت ارسال شد");
            case "ErrorSendingVerifyCode":
                return props.failed("مشکل در ارسال کد تایید");
            case "UserIsActive":
                return props.failed("با این شماره تلفن قبلا ثبت نام کرده اید");
            case "UserIsBlocked":
                return props.failed(
                    "اکانت شما به طور موقت غیر فعال شده است لطفا به پشتیبانی مراجعه کنید"
                );
            case "ErrorSendingVerifyCode":
                return props.failed("مشکل در ارسال کد تایید");
            case "AccessDenied":
                return props.failed("خطا در دسترسی");
            case "RunTimeError":
                return props.failed("خطای حین رانش ،لطفا دوباره تلاش کنید");
            case "IsLockedOut":
                return props.failed("لطفا دقایقی دیگر تلاش کنید");
            case "IsDatasIncorrected":
                return props.failed("اطلاعات وارد شده اشتباه می باشد");
            case "VerifyCodeIsNotCorrect":
                return props.failed("کد تایید صحیح نمی باشد.");
            default:
                return null;
        }
    }

    const handleClickShowPassword = () => {
        setShow(!show);
    };

    function steps(one, two, three, four) {
        setRegisterStep1(one);
        setRegisterStep2(two);
        setRegisterStep3(three);
        setRegisterStep4(four);
    }
    useEffect(() => {
        if (registerStep1) {
            if (data) {
                setLoading(false);
                alert(data.message);
                if (data.status === "ok") {
                    setDates(Date.now() + 50000);
                    steps(false, true, false, false);
                    dispatch({ type: USER_REGISTER_RESET });
                } else {
                    dispatch({ type: USER_REGISTER_RESET });
                }
            }
        }
    }, [data]);

    useEffect(() => {
        if (confirmData && confirmData.status === "ok") {
            const token = confirmData.token;
            setUserTokenLocal(token);
        }
        if (registerStep2) {
            if (confirmData) {
                setLoading(false);
                alert(confirmData.message);
                if (confirmData.status === "ok") {
                    steps(false, false, true, false);
                }
            }
        }
    }, [confirmData]);

    useEffect(() => {
        if (registerStep3) {
            if (userCreateData) {
                setLoading(false);
                alert(userCreateData.message);
                if (userCreateData.status === "ok") {
                    steps(false, false, false, true);
                    dispatch({ type: USER_REGISTER_RESET });
                }
            }
        }
    }, [userCreateData]);

    const handleEditNumber = () => {
        setRegisterStep2(false);
        setRegisterStep1(true);
        setResend(true);
        // dispatch({ type: USER_REGISTER_RESET });
    };

    const registerFetch = (body) => {
        setLoading(true);
        dispatch(register(body));
    };

    const resendCodeNow = () => {
        setDates(Date.now() + 50000);
        const body = {
            mobileNumber: registerMobileValue,
        };
        dispatch(register(body)).then(() => {
            props.success("کد تایید با موفقیت ارسال شد.");
            setResend(true);
        });
        dispatch({ type: USER_REGISTER_RESET });
    };

    const renderer = ({ hours, minutes, seconds }) => {
        return <span>{seconds}</span>;
    };

    return (
        <div>
            {registerStep1 && (
                <div>
                    <Formik
                        style={{ width: "100%" }}
                        initialValues={{
                            mobileNumber: "",
                            acceptTerms: false,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            setRegisterMobileValue(values.mobileNumber);
                            const body = {
                                mobileNumber: values.mobileNumber,
                            };
                            registerFetch(body);
                        }}
                        خانوادگی
                        render={({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box px={3}>
                                    <label className={classes.label}>شماره تلفن همراه</label>
                                    <TextField
                                        fullWidth
                                        name="mobileNumber"
                                        variant="outlined"
                                        value={values.mobileNumber}
                                        onChange={handleChange}
                                        error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                                        helperText={touched.mobileNumber && errors.mobileNumber}
                                    />
                                    <Box mt={1}>
                                        <Field
                                            type="checkbox"
                                            name="acceptTerms"
                                            id="acceptTerms"
                                        />
                                        <label for="acceptTerms" className="form-check-label">
                                            قوانین را می پذیرم
                    </label>
                                        <ErrorMessage
                                            name="acceptTerms"
                                            component="div"
                                            className={classes.red}
                                        />
                                    </Box>
                                    <Box mt={2} textAlign="center">
                                        <Button
                                            type="submit"
                                            disabled={loading}
                                            variant="contained"
                                            className="w-90 "
                                            color="secondary"
                                        >
                                            {loading ? <CircularProgress /> : "ارسال کد"}
                                        </Button>
                                    </Box>
                                </Box>
                            </form>
                        )}
                    />
                </div>
            )}
            {registerStep2 && (
                <div>
                    <Formik
                        style={{ width: "100%" }}
                        initialValues={{
                            ConfirmValue: "",
                        }}
                        validationSchema={validationConfirm}
                        onSubmit={(values) => {
                            setConfirmValue(values.ConfirmValue);
                            const body = {
                                mobileNumber: registerMobileValue,
                                verifyCode: values.ConfirmValue,
                            };
                            setLoading(true);
                            dispatch(confirmation(body));
                        }}
                        render={({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box px={3}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <label>کد ارسال شده</label>
                                            <TextField
                                                fullWidth
                                                name="ConfirmValue"
                                                variant="outlined"
                                                value={values.ConfirmValue}
                                                onChange={handleChange}
                                                error={
                                                    touched.ConfirmValue && Boolean(errors.ConfirmValue)
                                                }
                                                helperText={touched.ConfirmValue && errors.ConfirmValue}
                                            />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Box mt={2.9}>
                                                <Button
                                                    type="submit"
                                                    disabled={loading}
                                                    variant="contained"
                                                    className="w-90 "
                                                    color="secondary"
                                                >
                                                    {loading ? (
                                                        <CircularProgress size={30} />
                                                    ) : (
                                                        "بررسی"
                                                    )}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}
                    />
                    <Box px={3} mt={2}>
                        <div className=" mt-2">
                            {resend && (
                                <span className="shabnam text-secondary">
                                    <Countdown
                                        ref={clockRef}
                                        renderer={renderer}
                                        date={dates}
                                        onComplete={() => setResend(false)}
                                    />
                                    <span className="text-black"> ثانیه دیگر تا&nbsp;</span>
                                    <LoopIcon fontSize="small" style={{ marginBottom: "-6px" }} />
                  ارسال مجدد کد
                                </span>
                            )}
                            {!resend && (
                                <a onClick={resendCodeNow} className={classes.text}>
                                    <LoopIcon fontSize="small" style={{ marginBottom: "-6px" }} />
                  ارسال مجدد کد
                                </a>
                            )}
                        </div>
                        <Box mt={1}>
                            <a
                                onClick={handleEditNumber}
                                className={`${classes.text} pointer`}
                            >
                                <EditIcon fontSize="small" style={{ marginBottom: "-4px" }} />
                اصلاح شماره تلفن
              </a>
                        </Box>
                    </Box>
                </div>
            )}
            {registerStep3 && (
                <div>
                    <Box mt={2} textAlign="center">
                        <LockIcon style={{ marginBottom: "-8px" }} />
            برای ادامه لطفا اطلاعات خود را تکمیل نمایید.
          </Box>
                    <div>
                        <Formik
                            style={{ width: "100%" }}
                            initialValues={{
                                fullName: "",
                                password: "",
                                passwordRepeat: "",
                            }}
                            validationSchema={validationInfo}
                            onSubmit={(values) => {
                                const body = {
                                    mobileNumber: registerMobileValue,
                                    fullName: values.fullName,
                                    password: values.password,
                                    verifyCode: confirmValue,
                                };
                                setLoading(true);
                                dispatch(createPassword(body, userTokenLocal));
                            }}
                            render={({
                                handleSubmit,
                                handleChange,
                                values,
                                touched,
                                errors,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <Box px={3}>
                                        <label className={classes.label}>نام و نام خانوادگی</label>
                                        <TextField
                                            fullWidth
                                            name="fullName"
                                            variant="outlined"
                                            value={values.fullName}
                                            onChange={handleChange}
                                            error={touched.fullName && Boolean(errors.fullName)}
                                            helperText={touched.fullName && errors.fullName}
                                        />
                                        <label className={classes.label}>رمز عبور</label>
                                        <div dir="ltr"><TextField
                                            fullWidth
                                            type={show ? 'password' : 'text'}
                                            name="password"
                                            variant="outlined"
                                            value={values.password}
                                            onChange={handleChange}
                                            error={touched.password && Boolean(errors.password)}
                                            helperText={touched.password && errors.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            edge="end"
                                                        >
                                                            {show ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        /></div>
                                        <label className={classes.label}>تکرار رمز عبور</label>
                                        <div dir="ltr">
                                            <TextField
                                                fullWidth
                                                name="passwordRepeat"
                                                type={show ? 'password' : 'text'}
                                                variant="outlined"
                                                value={values.passwordRepeat}
                                                onChange={handleChange}
                                                error={
                                                    touched.passwordRepeat && Boolean(errors.passwordRepeat)
                                                }
                                                helperText={
                                                    touched.passwordRepeat && errors.passwordRepeat
                                                }
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                edge="end"
                                                            >
                                                                {show ? <Visibility /> : <VisibilityOff />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            /></div>

                                        <Box mt={2} textAlign="center">
                                            <Button
                                                type="submit"
                                                disabled={loading}
                                                variant="contained"
                                                className="w-90 "
                                                color="secondary"
                                            >
                                                {loading ? <CircularProgress /> : "تکمیل ثبت نام"}
                                            </Button>
                                        </Box>
                                    </Box>
                                </form>
                            )}
                        />
                    </div>
                </div>
            )}

            {registerStep4 && (
                <div>
                    <Box fontWeight="Bold" px={4} color="green" textAlign="center">
                        <img width="40%" src="/images/home-page-header/logo.png" />
                        <p>ثبت نام شما با موفقیت انجام شد</p>
                    </Box>

                    <Box fontWeight="bold" textAlign="center">
                        <Countdown
                            renderer={renderer}
                            onComplete={() => props.loginToggle()}
                            date={Date.now() + 4000}
                        />
                    </Box>
                </div>
            )}
        </div>
    );
};
